require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// ../node_modules/babel-runtime/node_modules/core-js/library/modules/es7.symbol.observable.js
// module id = 314
// module chunks = 0